import {Component, Input, OnInit} from '@angular/core';
import {Person} from '../../../class/person';
import {QuoteRowObject} from '../../../class/quote/quote-row-object';

interface ChartItem {
  name: string;
  value: number;
  type: number;
}

@Component({
  selector: 'app-quote-chart',
  templateUrl: './quote-chart.component.html',
  styleUrls: ['./quote-chart.component.css']
})
export class QuoteChartComponent implements OnInit {

  @Input()
  person: Person;

  @Input()
  colorScheme;

  values: ChartItem [] = [
    {
      name: 'Morte',
      value: 0,
      type: 0
    },
    {
      name: 'IP Capitale',
      value: 0,
      type: 1
    },
    {
      name: 'IP Rendita',
      value: 0,
      type: 2
    },
    {
      name: 'Non Autosufficenza',
      value: 0,
      type: 3
    },
    {
      name: 'Grave patologia (D.D)',
      value: 0,
      type: 4
    },
    {
      name: 'Terremoto',
      value: 0,
      type: 5
    },
    {
      name: 'Incendio',
      value: 0,
      type: 6
    },
    {
      name: 'RSC',
      value: 0,
      type: 7
    },
    {
      name: 'Servizi Dental',
      value: 0,
      type: 8
    },
    {
      name: 'Servizi Fisio',
      value: 0,
      type: 9
    }
  ];

  view: any[] = [550, 600];

  // options
  showXAxis = true;
  showYAxis = true;
  gradient = false;
  showLegend = false;
  showXAxisLabel = true;
  showYAxisLabel = true;
  chartPadding = 20;

  constructor() {
  }

  ngOnInit() {
    Object.assign(this, this.values);
  }

  public updateChart(rowValue: QuoteRowObject) {
    this.values.forEach(value => {
      if (value.type === rowValue.type) {
        value.value = rowValue.value;
      }
    });

    this.values = [...this.values];
  }
}
